
$(document).ready(function(){
  // Cart handling
  $(document).on('click', '#cart-icon-bubble', function (e) {
      e.preventDefault();
      document.addEventListener('rebuy.init', function (event) { });
  });
  document.addEventListener('rebuy.add', function (event) {
      document.dispatchEvent(new CustomEvent('cart:build'));
    setTimeout(function(){
           if ($('cart-drawer').hasClass('active')) {
          document.addEventListener('rebuy.refresh', function (event) {           
          });
      } else {
          const myBtn = document.getElementById('cart-icon-bubble');
          myBtn.click();
      } 
    },2000)

  });
  // Lazy loading images
      $('img').each(function () {
          var $img = $(this);
          if ($img.attr('data-src')) {
              $img.attr('src', $img.attr('data-src')).removeAttr('data-src');
          }
      });
      var imgTags = document.querySelectorAll('.article-template__content img');
      imgTags.forEach(function (img) {
          if (!img.hasAttribute('loading')) {
              img.setAttribute('loading', 'lazy');
          }
      });
  // YouTube player
  $(document).ready(function () {
      "use strict";
      function generateThumbnail(videoID) {
          return '<img src="https://i.ytimg.com/vi/' + videoID + '/maxresdefault.jpg" alt="YouTube Video Thumbnail">' + '<div aria-label="Play"  class="play" role="button"></div>';
      }
      function createYouTubePlayer() {
          var videoID = $(this).data('id');
          var iframe = $('<iframe>').attr('src', 'https://www.youtube.com/embed/' + videoID + '?autoplay=1&rel=0&mute=1').attr('frameborder', '0').attr('allowfullscreen', '1');
          $(this).replaceWith(iframe);
      }
      $(".youtube-player").each(function () {
          var videoID = $(this).data('id');
          var thumbnailDiv = $('<div>').attr('data-id', videoID).html(generateThumbnail(videoID)).on('click', createYouTubePlayer);
          $(this).append(thumbnailDiv);
      });
  });
  
  // Image swapping
  $(document).ready(function () {
      const imagesToSwap = document.querySelectorAll(".imageToSwap");
      imagesToSwap.forEach((imageToSwap) => {
          imageToSwap.addEventListener("click", () => {
              const dynamicId = imageToSwap.getAttribute("data-main-image-id");
              const mainImageId = `mainImage${dynamicId}`;
              const mainImage = document.getElementById(mainImageId);
              if (mainImage) {
                  const tempSrc = mainImage.src;
                  mainImage.src = imageToSwap.src;
                  imageToSwap.src = tempSrc;
              }
          });
      });
  
      // Function definition
      function toggleAnswer() {
          const collapseElement = document.getElementById("collapseOne");
          const h3Element = document.querySelector(".card-header h3 button");
          if (collapseElement.classList.contains("show")) {
              collapseElement.classList.remove("show");
              h3Element.setAttribute("aria-expanded", "false");
              h3Element.classList.add("collapsed");
          } else {
              collapseElement.classList.add("show");
              h3Element.setAttribute("aria-expanded", "true");
              h3Element.classList.remove("collapsed");
          }
      }
  });
$(document).on('click', '.block__section---productcontent--titlehide', function () {

  let $this = $(this);
  let $parent = $this.closest('.block__section---productcontent--hidespace');
  let $toggleShow = $parent.find('.block__section---productcontent--toggle-show');
  let $toggleText = $this.find('.toggle-text');

  


  if ($parent.hasClass('current')) {
    $parent.removeClass('current');
    $toggleText.text('View Specs');
    $toggleShow.slideUp('slow');
    $(this).parents(".block__section---productcontent--hidespace").attr("aria-expanded" , "false")
  } else {
    $parent.addClass('current');
    $toggleText.text('Hide Specs');
    $toggleShow.slideDown('slow');

    $(this).parents(".block__section---productcontent--hidespace").attr("aria-expanded" , "true")
  }
});
  $(document).on('click', '.block_collection_grid_swatch_list', function () {
     $(this).addClass("active").siblings().removeClass("active")
     $(this).parents(".block__section_product-card").find(".product-variant-id").attr("value", $(this).attr("data-id"))
     let price = $(this).attr("data-price")
     let cmpprice = $(this).attr("data-compare")
     $(this).parents(".block__section_product-card").find(".main--regular-price").html(price)
    $(this).parents(".block__section_product-card").find(".main-price").html(cmpprice)         
     });

    $(document).on('change', '.block_collection_select', function () {

  var selectedOption = this.options[this.selectedIndex];
  if (!selectedOption) return;

  var $card = $(this).closest(".block__section_product-card");

  $card.find(".product-variant-id")
       .val(selectedOption.dataset.id || '');

  $card.find(".main--regular-price")
       .html(selectedOption.dataset.price || '');

  $card.find(".main-price")
       .html(selectedOption.dataset.compare || selectedOption.dataset.price || '');

});

$(document).on('click', '.block__section_product-card .swatch_result span, .block__section---productcontent--color-opations .swatch_result_length', function() {
    $(this).closest('.block__section_product-card').find('.swatch_result span, .block__section---productcontent--color-opations .swatch_result_length').removeClass('value-color-active');
    $(this).addClass('value-color-active');
    var image_url = $(this).attr('data-image-url');
    $(this).closest('.block__section_product-card').find('.block__section-product-image img').attr('src', image_url);
});

$(function() {
  $('.acc__title').click(function(j) { 
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});
  
 var hash = window.location.hash; 
  if(hash != ''){
    $('.account-sidebar li').removeClass('active');
    $('[data-tab="'+hash+'"]').parent('li').addClass('active');   
    $('.account-tabs .account-tab').removeClass('active');
    $(hash).addClass('active');
  }
  
  $(document).on('click','.account-sidebar a.account-links',function(e) {
    e.preventDefault();
    var hash = $(this).data('tab');
    if(hash != undefined){
      var url = window.location.href; 
      if(url.indexOf('#') != -1){
        var arr = url.split('#');
        window.location.href = arr[0]+hash;
      }else{
        window.location.href = url+hash;
      }
      $('.account-sidebar li').removeClass('active');
      $('[data-tab="'+hash+'"]').parent('li').addClass('active');
      $('.account-tabs .account-tab').removeClass('active');
      $(hash).addClass('active');
      $("html").animate({  scrollTop: $(".account-tab").offset().top
    }, 2000);
    }else{
      var url = window.location.href;
      window.location.href = url.replace(window.location.hash, '');  
      $('.account-sidebar li').removeClass('active');
      $('.account-sidebar-nav li:first').addClass('active');
      $('.account-tabs .account-tab').removeClass('active');
      $('.account-tabs .account-tab:first').addClass('active');
      $("html").animate({  scrollTop: $(".account-tab").offset().top
    }, 2000);
    } 
  });

}); 


$(document).on('click', '.loading-overlay, .mobile-facets__close-icon', function() {
  if ($('.facets-vertical').hasClass('menuopen')) {
    $('.facets-vertical').removeClass('menuopen');
  } else {
    $('.facets-vertical').addClass('menuopen');
  }
});
 
    var maxPriceLTEValue = $('#Filter-Price-LTE').attr('max');
    var minPriceLTEValue = $('#Filter-Price-GTE').attr('min');
    $('#Filter-Price-GTE').attr('max', maxPriceLTEValue);
      updateDisplayedValues();
      $(document).on('change', '#Filter-Price-LTE', function () {

          updateDisplayedValues();
      });
    function updateDisplayedValues() {

        var maxPriceGTE = $('#Filter-Price-GTE').attr('max');
        var minPriceLTE = $('#Filter-Price-LTE').attr('min');
        var minPrice = $('#Filter-Price-GTE').val();
        var maxPrice = $('#Filter-Price-LTE').val();
        // Update the displayed values
        $('.filter-value1').text(minPriceLTE);
        $('.filter-value2').text(maxPrice);
    }


// Product Variant Dual
$('.product-form__input input[type="radio"]').on('change', function() {
    var selectedValue = $(this).val();
    var correspondingDiv = $('.goDual_image[data-variant-finish="' + selectedValue + '"]');
    var correspondingDiv_Price = $('.productForm_dualSavings[data-variant-finish="' + selectedValue + '"]');
    $('.goDual_image').addClass('hide');
    $('.productForm_dualSavings').addClass('hide');
    correspondingDiv.removeClass('hide');  
    correspondingDiv_Price.removeClass('hide');  
}); 
  $(document).ready(function () {
    // Set the first section as active and open its form by default
    $(".product-registration-inner:first").addClass("active");
    $(".product-registration-inner:first .product-registration-inner-form").show();
    
    $(".product-registration-inner-tabtitle").click(function () {
      // Toggle the display of the corresponding form
      $(this).next(".product-registration-inner-form").slideToggle(function () {
        // Check if the form is visible
        if ($(this).is(":visible")) {
          // If visible, add the 'active' class to the parent
          $(this).parent(".product-registration-inner").addClass("active");
        } else {
          // If not visible, remove the 'active' class from the parent
          $(this).parent(".product-registration-inner").removeClass("active");
        }
      });
    });
    
    $(".product-register-button.product-register-next").click(function () {
      // Close the current form
      var currentForm = $(this).closest(".product-registration-inner").find(".product-registration-inner-form");
      if (currentForm.is(":visible")) {
        currentForm.slideUp();
        $(this).closest(".product-registration-inner").removeClass("active");
      }
      
      // Open the next section (parent)
      var nextSection = $(this).closest(".product-registration-inner").next(".product-registration-inner");
      if (nextSection.length > 0) {
        nextSection.find(".product-registration-inner-form").slideDown();
        nextSection.addClass("active");
      }
    });
setTimeout(function(){ 
    document.addEventListener('DOMContentLoaded', function() {
    var splideList = document.querySelector('.splide__list');
    var rebuyProductBlocks = splideList.querySelectorAll('.rebuy-product-block');
    rebuyProductBlocks.forEach(function(block) {
      var wrapper = document.createElement('div');
      wrapper.className = 'rebuy-wrapper';
      block.parentNode.insertBefore(wrapper, block);
      wrapper.appendChild(block);
    });
  });
  }, 5000);
  });
    document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        if ($("#recentlyProduct .slick-track").children().length >= 2) {
            $("#recentlyProduct").show();
        } else {
            $("#recentlyProduct").hide(); 
        }
    }, 1000);
});
$(document).ready(function(){ 
    checkScreenSize();
    $(window).resize(function(){
        checkScreenSize();
    });

    function checkScreenSize(){
        var productModelDual = $('.product-model-dual');

        if ($(window).width() < 576) {
            productModelDual.insertAfter('.productForm_dualSavings:last');
        }
    }
});

$(document).ready(function(){
  function updateTierInfo() {
      var x = parseInt($(".data-item_tier").html());
      $(".next-tier").hide();
      if (x < 0) {
          $(".tier_text").hide();
      } else if (x >= 1 && x <= 1199) {
          $(".next-tier").show();
          var point = 1199 - x;
          $(".next-tier .tier-name").html("Silver");
          $(".more-point").html(point);
      } else if (x >= 1200 && x <= 4999) {
          $(".next-tier").show();
          var point = 4999 - x;
          $(".next-tier .tier-name").html("Gold");
          $(".more-point").html(point);
      } else if (x >= 5000) {
          $(".next-tier").show();
          // Add logic here if needed for x >= 5000
      }       
  }

  setTimeout(function(){     
  updateTierInfo();
}, 2000); 
  // Call the function when .lion-action-button is clicked
  $(document).on("click",".lion-action-button",function(){
    setTimeout(function(){  
      updateTierInfo();
    }, 5000);
  });
});



$(document).on("click",".drawer__footer .rebuy-button,.drawer__footer .rebuy-product-actions span",function(){
    var interval = setInterval(doStuff, 100);
    function doStuff() {
      if(!$(".rebuy-button").hasClass("working")){
   $.ajax({
        url: '/?section_id=cart-drawer',
        type: 'GET',
        dataType: 'html',
        success:function(carthtml) {
          $("#CartDrawer").html($(carthtml).find('#CartDrawer').html());
          $.ajax({
            url: '/?section_id=cart-icon-bubble',
            type: 'GET',
            dataType: 'html',
            success:function(itemcount) {
              $("#cart-icon-bubble").html($(itemcount).html());
              $(".cart-count-bubble").trigger("click");
            },
            complete:function(){
              window.loyaltylion && window.loyaltylion.ui.refresh();
              Rebuy.init();
            }
          });
        }

      });
        clearInterval(interval);
      }
    }
  });
 $(document).ready(function() {
    $('.listCollections_collectionWrapper').hide();
    $('.navBarFilterLink').on('click', function() {
      var filterTag = $(this).data('filter-tag');
      $('.navBarFilterLink').removeClass('active');
      $(this).addClass('active'); 
      if (filterTag === 'all') {
        $('.listCollections_collectionWrapper').show();
      } else {
        $('.listCollections_collectionWrapper').hide();
        $('.listCollections_collectionWrapper[data-filter-tag="' + filterTag + '"]').show();
      }
    });
  })
 $(document).ready(function() {
    // Show all collection wrappers initially
    $('.listCollections_collectionWrapper').show(); 

    // Event handler for navbar filter links
    $('.navBarFilterLink').on('click', function() {
      var filterTag = $(this).data('filter-tag');
      
      // Remove 'active' class from all links and add it to the clicked one
      $('.navBarFilterLink').removeClass('active');
      $(this).addClass('active');

      // Update the selected option in the dropdown
      $('.filterNavbarSelect').val(filterTag);

      // Hide all collection wrappers and show only the ones with the matching filter tag
      if (filterTag === 'all') {
        $('.listCollections_collectionWrapper').show();
      } else {
        $('.listCollections_collectionWrapper').hide();
        $('.listCollections_collectionWrapper[data-filter-tag="' + filterTag + '"]').show();
      }
    });

    // Event handler for dropdown change
    $('.filterNavbarSelect').on('change', function() {
      var filterTag = $(this).val();
      
      // Remove 'active' class from all links
      $('.navBarFilterLink').removeClass('active');
      // Add 'active' class to the button with matching filter tag
      $('.navBarFilterLink[data-filter-tag="' + filterTag + '"]').addClass('active');

      // Hide all collection wrappers and show only the ones with the matching filter tag
      if (filterTag === 'all') {
        $('.listCollections_collectionWrapper').show();
      } else {
        $('.listCollections_collectionWrapper').hide();
        $('.listCollections_collectionWrapper[data-filter-tag="' + filterTag + '"]').show();
      }
    });
  });

$(document).ready(function() {
  var bgsetImage = $('.setuprow').attr('data-bgset');
  $('.setuprow').css('background-image', 'url(' + bgsetImage + ')');
});

 
// Compare JS
function compare(Cookies) {
    "use strict";

    var options = {
        compareCheckboxes: "[data-compare-product-handle]",
        compareCheckboxesProductType: "[data-product-compare-type]",
        compareBlock: ".productCompare_block",
        compareCount: "#compareCount",
        compareFullNotification: "#compareRemoveMessage",
        compareRemoves: ".productCompareBlock_remove",
        compareContinueShopping: "[data-continue-shopping]",
        compareProduct1: "#productCompareProduct1",
        compareProduct2: "#productCompareProduct2",
        compareProduct3: "#productCompareProduct3",
        compareProduct1Image: "#productCompare1Image",
        compareProduct2Image: "#productCompare2Image",
        compareProduct3Image: "#productCompare3Image",
        compareProduct1Title: "#productCompare1Title",
        compareProduct2Title: "#productCompare2Title",
        compareProduct3Title: "#productCompare3Title",
        compareProduct1Price: "#productCompare1Price",
        compareProduct2Price: "#productCompare2Price",
        compareProduct3Price: "#productCompare3Price",
        compareProduct1Cta: "#productCompare1Cta",
        compareProduct2Cta: "#productCompare2Cta",
        compareProduct3Cta: "#productCompare3Cta",
    };

    var productCompare1 = '';
    var productCompare2 = '';
    var productCompare3 = '';
    var handle = '';
    var productType = '';

    function initialize() {
        $('.productCompareBlock_product').addClass('hide');
       
      $(document).on("change", '[data-compare-product-handle]', function(event) {
            handle = $(this).data("compare-product-handle");
            productType = $(this).closest('.productCompare_checkbox').data("product-compare-type");
            if ($(this).is(':checked')) {
                if ($.cookie("product_compare1") == null) {
                    $.cookie("product_compare1", handle, { path: '/' });
                    $.cookie("product_type", productType, { path: '/' });
                } else if ($.cookie("product_compare1") != null && $.cookie("product_compare2") == null) {
                    $.cookie("product_compare2", handle, { path: '/' });
                    $.cookie("product_type", productType, { path: '/' });
                } else if ($.cookie("product_compare1") != null && $.cookie("product_compare2") != null && $.cookie("product_compare3") == null) {
                    $.cookie("product_compare3", handle, { path: '/' });
                    $.cookie("product_type", productType, { path: '/' });
                }
            } else {
                var dataPro = $(this).attr('data-compare-product-handle');
                $('.productCompareBlock_product[data-product-handle="' + dataPro + '"]').addClass('hide')
                if ($.cookie("product_compare1") == handle) {
                    $.removeCookie("product_compare1", { path: '/' });
                    $.removeCookie("product_type", { path: '/' });
                } else if ($.cookie("product_compare2") == handle) {
                    $.removeCookie("product_compare2", { path: '/' });
                     $.removeCookie("product_type", { path: '/' });
                } else if ($.cookie("product_compare3") == handle) {
                    $.removeCookie("product_compare3", { path: '/' });
                     $.removeCookie("product_type", { path: '/' });
                }
            }
            productCompare1 = $.cookie("product_compare1");
            productCompare2 = $.cookie("product_compare2");
            productCompare3 = $.cookie("product_compare3");
            productType = $.cookie("product_type");
            $('.productCompare_block').addClass('show');
            
            loadComparisonData(productCompare1, productCompare2, productCompare3,productType);
            updateComparisonDisplay();
            if (window.location.pathname == '/pages/compare-page') {
                populatePage();
            }
            return false;
            handleType();
        });

       $(document).on("click", options.compareRemoves, function(event,productType) {
            var handleToRemove = $(event.currentTarget).data("compare-remove-product");
            handleCheckboxUncheck(handleToRemove);
            $.removeCookie(handleToRemove, { path: '/' });
            $.removeCookie("product_type", { path: '/' });           
            $(this).parents('.productCompareBlock_product').addClass('hide');
            updateComparisonDisplay();
            handleType(productType);
            return false;
        });

       $(document).on("click", options.compareContinueShopping, function(event,productType) {
            productCompare1 = $.cookie("product_compare1");
            productCompare2 = $.cookie("product_compare2");
            productCompare3 = $.cookie("product_compare3");
             
            $.removeCookie("product_compare1", { path: '/' });
            $.removeCookie("product_compare2", { path: '/' });
            $.removeCookie("product_compare3", { path: '/' });
            $.removeCookie("product_type", { path: '/' });
            handleType(productType);
            $('.productCompareBlock_product').addClass('hide');
            $("[data-compare-product-handle]").prop("checked", false);
            hideComparisonBlock();
            if (window.location.pathname == '/pages/compare-page') {
                populatePage();
            }
            return false;     
            
        });
    }
 
      
         

    function loadComparisonData(productCompare1, productCompare2, productCompare3,productType) {
        if (productCompare1) {
            populatePage();
            handleProductComparison(productCompare1, "Product1");
            handleType(productType)
        }
        if (productCompare2) {
            handleProductComparison(productCompare2, "Product2");
            handleType(productType)
           
        }
        if (productCompare3) {
            handleProductComparison(productCompare3, "Product3");
            handleType(productType)
          
        }
    }

    function handleProductComparison(handle, productNumber) {
        var url = "/products/" + handle + ".js";
        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            success: function(data) {
                updateComparisonDisplayForProduct(data, productNumber);
                handleCheckboxChange(handle,productType);
                handleType(productType)
            }
        });
    }



    function updateComparisonDisplayForProduct(data, productNumber) {
        var productContainer = $(options["compare" + productNumber]);
        var imageSelector = options["compare" + productNumber + "Image"];
        var titleSelector = options["compare" + productNumber + "Title"];
        var priceSelector = options["compare" + productNumber + "Price"];
        var ctaSelector = options["compare" + productNumber + "Cta"];

        productContainer.find(imageSelector).attr("src", data.featured_image);
        productContainer.find(titleSelector).html(data.title);
        productContainer.attr("data-product-handle", data.handle)

        var formattedPrice = (data.price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
        productContainer.find(priceSelector).html("$" + formattedPrice);
        productContainer.find(ctaSelector).attr("href", data.url);

        productContainer.removeClass("hide");
        updateComparisonDisplay();
    }

    function handleCheckboxChange(handle, productType) {
        $(options.compareCheckboxes + "[data-compare-product-handle=" + handle + "]").prop("checked", true);
        handleType(productType);
    }
    var productType = $.cookie("product_type");

      function handleType(productType) {  
   if (productType === "subwoofer" || productType === "Subwoofer") {
        $(options.compareCheckboxesProductType + '[data-product-compare-type="Speaker"]').hide();
        $(options.compareCheckboxesProductType + '[data-product-compare-type="speaker"]').hide();;
    } else if (productType === "speakers" || productType === "Speaker") {
        $(options.compareCheckboxesProductType + '[data-product-compare-type="Subwoofer"]').hide();;
        $(options.compareCheckboxesProductType + '[data-product-compare-type="subwoofer"]').hide();;
    } else if (productType === "none") {
        $(options.compareCheckboxesProductType + '[data-product-compare-type="Speaker"]').show();
        $(options.compareCheckboxesProductType + '[data-product-compare-type="Subwoofer"]').show();
    }
     else if (productType !== undefined) {
         $(options.compareCheckboxesProductType + '[data-product-compare-type="Speaker"]').show();
        $(options.compareCheckboxesProductType + '[data-product-compare-type="Subwoofer"]').show();
    }
    else if (productType === undefined) {
         $(options.compareCheckboxesProductType + '[data-product-compare-type="Speaker"]').show();
        $(options.compareCheckboxesProductType + '[data-product-compare-type="Subwoofer"]').show();
    }
  }

  if (productType === undefined) {
    $(options.compareCheckboxesProductType + '[data-product-compare-type="Speaker"]').show();
    $(options.compareCheckboxesProductType + '[data-product-compare-type="Subwoofer"]').show();
} else {
    handleType(productType);
}


    function handleCheckboxUncheck(handleToRemove,productType) {
        var checkboxUnchecked = handleToRemove;
        var unchecked = $.cookie(checkboxUnchecked);
        $(options.compareCheckboxes + "[data-compare-product-handle=" + unchecked + "]").prop("checked", false); 
        handleType(productType)

    }

    function updateComparisonCount() {
        var count = 0;
        if ($.cookie("product_compare1")) count++;
        if ($.cookie("product_compare2")) count++;
        if ($.cookie("product_compare3")) count++;

        var itemsText = count === 1 ? " item" : " items";
        $(options.compareCount).html(count.toString() + itemsText);
    }

    function updateComparisonDisplay() {
        var count = 0;
        if ($.cookie("product_compare1")) count++;
        if ($.cookie("product_compare2")) count++;
        if ($.cookie("product_compare3")) count++;
        if (count === 0) {
            hideComparisonBlock();
        } else {
            $(options.compareBlock).addClass("show");
            updateComparisonCount();
            if (count === 3) {
                showFullNotification();
            } else {
                hideFullNotification();
            }
        }
    }

    function showFullNotification() {
        $(options.compareFullNotification).removeClass("hide");
    }

    function hideFullNotification() {
        $(options.compareFullNotification).addClass("hide");
    }

    function hideComparisonBlock() {
        $(options.compareBlock).removeClass("show");
    }

    initialize();

    var product11Handle = $.cookie('product_compare1');
    var product22Handle = $.cookie('product_compare2');
    var product33Handle = $.cookie('product_compare3');
    var product_typeHandle = $.cookie('product_type');
    loadComparisonData(product11Handle, product22Handle, product33Handle, product_typeHandle);

};

compare();

    $(document).ready(function() {
   
        $('img:not([alt])').each(function() {
            // Get the image filename
            var filename = $(this).attr('src').split('/').pop().split('.')[0];

            // Capitalize the filename and replace hyphens with spaces
            var relevantText = filename.replace(/-+/g, ' ').replace(/\b\w/g, function(firstLetter) {
                return firstLetter.toUpperCase();
            });

            // Add relevant text to alt attribute
            $(this).attr('alt', relevantText);
        });
    });
    
    $(document).ready(function() {
      // Jab #conf-list ke kisi bhi list item par click kiya jaye
        $(document).on("click", "#conf-list li", function (event) {
          // Us element ke andar 'a' tag ko find karna aur uska data-description attribute ka value nikalna
          var description = $(this).find('a').attr('data-description');
          
          // Agar description hai
          if (description) {
              // Pehle builder-alert ko remove karo
              $('.builder-alert').remove();
              
              // Naya div element banakar usmein description aur close button daalo
              var newDiv = $('<div>').addClass('builder-alert alert alert-success').append(
                  $('<a>').attr({
                      href: '#',
                      class: 'close',
                      'data-dismiss': 'alert',
                      'aria-label': 'close'
                  }).text('×'),
                  description
              );
              
              // #builders-list mein naye div ko append karo
              $('#builders-list').append(newDiv);
          }
      });
  });
$(document).ready(function () {
    $(document).on("click", ".block-section-promocode_button .btn", function (event) {
        event.preventDefault();
        var promoCodeId = $(this).closest(".block-section-promocode_button").find("label").attr("value");

        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(promoCodeId).select();
        document.execCommand("copy");
        $temp.remove();

        alert("Promo code copied: " + promoCodeId);
    });
});

$(document).ready(function() {
    $('.product__title .rating-pdp-heading, .product__title .rating-icon, .product__title .rating--text, .product__title .rating-count').click(function() {
        var reviewsTab = $('.product-tab[data-product-tab="reviews"]');
        var reviewsSection = $('.product-tab-main[data-product-tab="reviews"]');
        var productDescriptionSection = $('.product-descripation-main'); 

        // Remove current-tab class from all product-tab elements
        $('.product-tab').removeClass('current-tab');

        // Add the class to make the reviews tab active
        reviewsTab.addClass('current-tab');

        // Remove is-hidden-tab class from all other .product-tab-main elements
        $('.product-tab-main').not(reviewsSection).addClass('is-hidden-tab').removeClass('current-tab');

        // Remove is-hidden-tab class from the clicked .product-tab-main
        reviewsSection.removeClass('is-hidden-tab').addClass('current-tab');

        // Scroll to the reviews section
         productDescriptionSection[0].scrollIntoView({ behavior: 'smooth' });

    });
});

function equl(name){ 
      var heading = document.querySelectorAll(name);
      var titleHeight = 0;
      heading.forEach((title) => {
          var matchHeight = title.clientHeight;
          if (matchHeight > titleHeight) {
              titleHeight = title.clientHeight;
          }
      });
      heading.forEach((divHeight) => {
          divHeight.style.minHeight = titleHeight + "px";
      });
  } 

setTimeout(function() { 
equl(".productCompare_checkbox");
equl(".block__section-product-content-inner .card-product-descripation");
equl(".productCompare_checkbox");
equl(".block__section-product-content-inner h4");
equl(".block__section---productcontent--color");
}, 1000);
$(document).ready(function() {
    $('img').lazyload({ 
        threshold : 200,
        effect: 'fadeIn'
    });
});   


$(document).on('keydown', function(event) {
  if (event.key == "Escape") {
      $(".compare-products-svg").trigger("click");
      $(".Details-menu-drawer-container .header__icon").trigger("click");
  
      $(".header__icon--menu:before").css("background" , "transparent")
      
  }
});
// ============new.js===============

$(document).on("click", ".recommended .rebuy-button, .recommended .rebuy-button span", function() {  

  setTimeout(function() {
     fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
          .then((response) => response.text())
          .then((responseText) => {
              const cartid = 'CartDrawer';
              const html = new DOMParser().parseFromString(responseText, 'text/html')
              const destination = document.querySelector('#CartDrawer');
              const source = html.getElementById(cartid);
              if (source && destination) destination.innerHTML = source.innerHTML;                      
              $.ajax({
                  url: '/?section_id=cart-icon-bubble',
                  type: 'GET',
                  dataType: 'html',
                  success: function(itemcount) {
                      $("#cart-icon-bubble").html($(itemcount).html());
                      $(".cart-count-bubble").trigger("click");          
                      window.loyaltylion && window.loyaltylion.ui.refresh(); 
                      Rebuy.init();
                  }
              });
          });
        }, 2000);
});

$(document).on("click", ".pdp-new-complete .rebuy-button, .pdp-new-complete .rebuy-button span  , .rebuy-button , .rebuy-button span" , function() {  
    var interval = setInterval(doStuff, 100);
    function doStuff() {
      if(!$(".rebuy-button").hasClass("working")){
        $.ajax({
          url: '/?section_id=cart-drawer',
          type: 'GET',
          dataType: 'html',
          success:function(carthtml) {
              $('cart-drawer').html($(carthtml).find('cart-drawer').html());
              $.ajax({
                  url: '/?section_id=cart-icon-bubble',
                  type: 'GET',
                  dataType: 'html',
                  success: function(itemcount) {
                    $("#cart-icon-bubble").html($(itemcount).html());
                    if($(".drawer").hasClass("is-empty")){
                      $(".drawer").removeClass("is-empty");
                    }
                    window.loyaltylion && window.loyaltylion.ui.refresh();
                    Rebuy.init();
                  }
              });
          }
        });  
        clearInterval(interval);
      }
    }
  
});

if( screen.width < 768 ){
  $('.tg-product-container').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [      
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }     
    ]
  });
}




(function($, window) {
	var adjustAnchor = function() {
		var $anchor = $(':target'),
		fixedElementHeight = 100;
    $('html, body').stop();
		if ($anchor.length > 0) {
      setTimeout(function(){
        window.scrollTo(0, $(".page-sticky-with-content-flex").offset().top - fixedElementHeight);	
      })
       
        $anchor.trigger("click"); 
		}
	};
	$(window).on('hashchange load', function() {      
		adjustAnchor();
	});
	})(jQuery, window);


document.addEventListener("DOMContentLoaded", function () {

  // Only show modal once per browsing session
  const dismissed = sessionStorage.getItem("caModalDismissed") === "true";

  const modalHTML = `
    <div id="CanadaModal" class="modal is-open" role="dialog" aria-modal="true" aria-label="Canada Store Selector">
      <div class="modal-wrapper">
        <span class="close1" aria-label="Close modal">&times;</span>

        <div class="canada-modal-content">
          <img src="https://www.svsound.com/cdn/shop/files/svs-mobile-logo.png"
               class="svs-modal-logo"
               alt="SVS US Logo">

          <p>Hi! Looks like you're browsing from Canada.<br/>Want to visit your local SVS store?</p>

          <div class="flags">
            <div class="flag-option">
              <a href="https://svsound.ca/">
                <img src="https://cdn.shopify.com/s/files/1/0921/3560/files/canadian-flag-svs.jpg?v=1690289645"
                     alt="SVS Canada Store - Canadian Flag">
              </a>
              <a href="https://svsound.ca/">
                Yes, Please
              </a>
            </div>

            <div class="flag-option">
              <a href="#" id="closebtn2" onclick="return false;">
                <img src="https://cdn.shopify.com/s/files/1/0921/3560/files/american-flag-svs.jpg?v=1690289645"
                     alt="SVS US Store - US Flag">
              </a>
              <a href="#" id="closebtn" onclick="return false;">
                No, Thanks
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  function injectCanadaModal() {
    if (document.getElementById("CanadaModal")) return;
    document.body.insertAdjacentHTML("beforeend", modalHTML);
    const modal = document.getElementById("CanadaModal");
    // --- SCROLL LOCK FIX ---
    function lockScroll() {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = scrollBarWidth + "px";
    }
    function unlockScroll() {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
    function closeModal() {
      sessionStorage.setItem("caModalDismissed", "true");
      unlockScroll();
      modal.remove();
    }
    lockScroll();
    // close handlers
    modal.querySelector(".close1").addEventListener("click", closeModal);
    modal.querySelector("#closebtn").addEventListener("click", closeModal);
    modal.querySelector("#closebtn2").addEventListener("click", closeModal);
    modal.addEventListener("click", function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeModal();
    }, { once: true });
  }
  
  function handleCountry(country) {
  document.body.classList.remove("fromOther", "fromCA");

  if (country === "US") return;

  document.body.classList.add("fromOther");

  if (country === "CA") {
    document.body.classList.add("fromCA");
    if (!dismissed) {
      requestAnimationFrame(() => injectCanadaModal());
    }
  }
}
  // Geo lookup

  const cachedCountry = localStorage.getItem("visitorCountry");
const cacheExpiry = localStorage.getItem("visitorCountryExpiry");
const now = Date.now();

if (cachedCountry && cacheExpiry && now < parseInt(cacheExpiry, 10)) {
  handleCountry(cachedCountry);
} else {
  fetchGeo();
}

function fetchGeo() {
  fetch("https://api.ipstack.com/check?access_key=ec4f23065c7a5b6f18e700a157f86a5e&format=1")
    .then(r => r.json())
    .then(data => {
      const country = data && data.country_code;
      if (!country) return;

      localStorage.setItem("visitorCountry", country);
      localStorage.setItem(
        "visitorCountryExpiry",
        Date.now() + 24 * 60 * 60 * 1000
      );

      handleCountry(country);
    })
    .catch(() => {});
}

});











